export default __webpack_public_path__ + "static/media/5378.81242c62.png";